const Root = "https://hubcore.morabaaapps.com";
const APIRoot = `${Root}/api/v1`;

export { Root, APIRoot };
